import { Flex, FlexProps } from "@chakra-ui/react";
import { ReactNode } from "react";

interface ButtonWrapperProps extends FlexProps {
  children: ReactNode;
}

export function ButtonWrapper({ children, ...rest }: ButtonWrapperProps) {
  return (
    <Flex gap={4} {...rest}>
      {children}
    </Flex>
  );
}
